<template>
    <div class="login-screen">

        <div v-if="daysToChristmas > -3 && daysToChristmas <= 30" class="login-wrapper p-5 d-none d-md-block d-lg-block">
            <div class="row">
                <div class="col-4">
                    <img class="float-right" src="/assets/tonttu.png">
                </div>
                <div v-if="daysToChristmas === 1" class="col-6 p-t-30">
                    <h3 class="text-danger">Joulu on huomenna!</h3>
                </div>
                <div v-else-if="daysToChristmas > 0" class="col-6 p-t-30">
                    <h3 class="text-danger">Jouluun on enää<br />{{ daysToChristmas }} päivää!</h3>
                </div>
                <div v-else class="col-6 p-t-30">
                    <h3 class="text-danger">Hyvää<br />Joulua!</h3>
                </div>
            </div>
        </div>

        <div class="login-wrapper">

            <!-- logo -->
            <div id="logo">
                <img class="logo" src="/assets/logo.png" alt="logo">
            </div>
            <!-- ./ logo -->

            <!-- form -->
            <div id="loginForm" v-if="loginStatus !== true">
                <form @submit="login">
                    <div v-if="loginStatus >= 400" class="alert alert-danger" role="alert">Virheellinen käyttäjänimi tai salasana</div>
                    <div class="form-group">
                        <label>Sähköposti:</label>
                        <input type="text" class="form-control" name="email" id="email" v-model="email" placeholder="Sähköposti" required="required" autofocus="" autocomplete="off">
                    </div>
                    <div class="form-group">
                        <label for="password">Salasana:</label>
                        <input type="password" id="password" v-model="password" class="form-control" placeholder="Salasana" required="required" autocomplete="off">
                    </div>
                    <div style="padding-top: 40px">
                        <button class="btn btn-primary btn-block" :disabled="loginStatus === true" @click="login">Kirjaudu</button>
                    </div>
                </form>
            </div>
            <div id="loginLoader" v-else>
                <div class="spinner-border text-warning" role="status">
                    <span class="sr-only">Kirjaudutaan...</span>
                </div>
                <div class="text-warning" style="padding-top: 10px; font-size: 120%">Kirjaudutaan palveluun...</div>
            </div>
            <!--
            <div class="form-group d-flex justify-content-between align-items-center">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" checked="" id="customCheck1">
                    <label class="custom-control-label" for="customCheck1">Remember me</label>
                </div>
                <a class="small" href="recovery-password.html">Reset password</a>
            </div>
            -->
            <!-- ./ form -->


        </div>
    </div>
</template>

<script>
    import session from "../../store/session";

    export default {
        name: "Login",
        data: function () {
            return {
                email: '',
                password: ''
            }
        },
        computed: {
            loginStatus () {
                return session.state.session.sessionLogin;
            },
            daysToChristmas() {
                const currentDate = new Date()
                const xmasDate = new Date('2023-12-24')
                const timeDifference = xmasDate.getTime() - currentDate.getTime();
                return Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1
            }
        },
        methods: {
            login: function () {
                let auth = {
                    username: this.email,
                    password: this.password
                }
                this.$store.dispatch('login', auth)
            }
        },
        watch: {
            loginStatus (val) {
                console.log('xo ' + val)
            }

        }
    }
</script>

<style scoped>
    .login-screen {
        position: fixed;
        width: 100%;
        height: 100%;
        background-image: url("/assets/login-background.jpg");
        background-size: cover;
        background-position: center;
    }

    .logo {
        max-height: 120px;
        padding-bottom: 30px;
    }

    .login-wrapper {
        background-color: white;
        padding: 3rem;
        border-radius: 0.8rem;
        border: solid 1px #f18b20;
        width: 400px;
        margin: 50px auto;
        text-align: center;
    }

    label {
        text-align: left;
        float: left;
        padding-bottom: 0;
        margin-bottom: 2px;
        color: gray;
        font-size: 90%;
    }

    #loginForm {
        min-height: 130px;
    }

    #loginLoader {
        min-height: 130px;
        padding-top: 30px;
    }
</style>
